import { bemBuilder } from "@chatfood/core-utils";

const className = "auto-discount-applied-modal";

export const css = bemBuilder(className);
export const cssq = bemBuilder(className, true);
